import script from "./AlertsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsPanel.vue?vue&type=script&setup=true&lang=js"

import "./AlertsPanel.vue?vue&type=style&index=0&id=56ec9b2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ec9b2c"]])

export default __exports__